import { Grid, Typography, Box, Divider } from "@mui/material";

const ContentBox = ({ word, description, isHeading }) => {

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: isHeading ? "bold" : "normal",
              color: isHeading ? "rgba(0, 0, 0, 0.8)" : "inherit",
            }}
          >
            {word}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: isHeading ? "bold" : "normal",
              color: isHeading ? "rgba(0, 0, 0, 0.8)" : "inherit",
            }}
          >
            {description}
          </Typography>
        </Grid>
      </Grid>
      <Divider
        sx={{
          my: 2,
          borderBottomWidth: 2,
          backgroundColor: isHeading
            ? "rgba(0, 0, 0, 0.5)"
            : "rgba(0, 0, 0, 0.3)",
        }}
      />
    </Box>
  );
};

export default ContentBox;

